import React from "react";
import { cn } from "utils";

const IconButton = React.forwardRef(({
    size = "small",
    className,
    children,
    ...rest
}, ref) => {
    return (
        <button
            className={cn(
                'icon-button',
                size === "small" ?
                'small' : ''
            )}
            ref={ref}
            {...rest}
        >
            {children}
        </button>
    )
})

IconButton.displayName = "IconButton";

export default IconButton;